import Vue from "vue";

export const modelStore = Vue.observable({
  selectedModel: "All",
  isFetching: false,
  isSpaced: false,
});

export const setSelectedModel = (value) => {
  modelStore.selectedModel = value;
};

export const setIsFetching = (value) => {
  modelStore.isFetching = value;
};

export function toggleFlagChange(val) {
  modelStore.isSpaced = val;
}
